module.exports = __webpack_public_path__ + "static/media/img-1.0c2330ee.jpg";